export const platformType = {
  INSTAGRAM: 'INSTAGRAM',
  TIKTOK: 'TIKTOK',
};

export const mediaFormat = {
  SQUARE: 'SQUARE',
  PORTRAIT: 'PORTRAIT',
};
